import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlloxCommonAsyncPipe, IAlloxAsyncPipeFetch, IAlloxAsyncPipeOption } from './allox-common-async.pipe';
import { Placement, PlacementService, PlacementSearchParam, ConstantsService } from '@app/core';

export interface IPlacementPipeOption extends IAlloxAsyncPipeOption {
  outerPlacementId?: boolean;
  name?: boolean;
  site?: boolean;
  page?: boolean;
  publisher?: boolean;
  hasAssets?: boolean;
}

@Pipe({
    name: 'placement', pure: false,
    standalone: false
})
export class PlacementPipe
  extends AlloxCommonAsyncPipe<Placement>
  implements IAlloxAsyncPipeFetch<Placement>, PipeTransform {

  constructor(
    private service: PlacementService,
    changeDetectorRef: ChangeDetectorRef,
    router: Router,
    protected constants: ConstantsService
  ) {
    super(changeDetectorRef, router);
  }

  fetchDependency(value: number) {
    return this.service.fetch(value, new PlacementSearchParam(this.constants.PlacementSearchMode.LINK));
  }

  makeText(value: number, obj: Placement, option?: IPlacementPipeOption) {
    if (!obj) {
      return `Unknown [id: ${value}]`;
    }
    const opt = option || { name: true };
    if (opt.site) {
      return `${obj.site.name}`;
    }
    if (opt.page) {
      return `${obj.page.name}`;
    }
    if (opt.publisher) {
      return `${obj.publisher.name}`;
    }
    if (opt.outerPlacementId) {
      return `${obj.outerPlacementId}`;
    }
    if (opt.hasAssets) {
      return obj.hasAssets ? this.constants.PlacementHasAsset.HAS_ASSET : this.constants.PlacementHasAsset.NOT_HAS_ASSET;
    }
    return obj.name;
  }
}
